import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CreateShopRequest } from '../requests/create.shop.request';
import { State } from '../redux/redux.state';
import client from '../clients/client';

const initialState: State<{}> = {
  data: {},
  status: 'idle',
};

export const createNewShop = createAsyncThunk(
  'createShop',
  async (request: CreateShopRequest, { rejectWithValue }) => {
    try {
      const { data } = await client.post('/shops', request);
      return data;
    } catch (error: any) {
      const { status, data } = error.response;
      return rejectWithValue({ status, errorMessage: data });
    }
  }
);

const slice = createSlice({
  name: 'newShopReducer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createNewShop.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createNewShop.fulfilled, (state) => {
        state.status = 'successful';
      })
      .addCase(createNewShop.rejected, (state, action) => {
        state.status = 'error';
        state.errors = action.payload;
      });
  },
});

export default slice.reducer;
